/* Nightform — figures that count up when they come into view.

   Progressive by design. The real number is rendered by Liquid and sits in the
   HTML. Three rules keep it safe:

   1. Every reason to bail out is checked BEFORE anything is touched, so a browser
      without IntersectionObserver, or a visitor who has asked for reduced motion,
      is left looking at the correct figure.
   2. A number is only set to zero at the moment its animation starts — inside the
      reveal, while the block is still faded out. Nothing is ever left sitting at
      zero because a frame never arrived.
   3. Nothing runs while the page is hidden. A tab opened in the background stops
      receiving animation frames, so a count started there would jump rather than
      run; it waits for the tab to be looked at instead.

   Only clean numbers animate. "1 in 4" carries no data-count, so it is revealed
   with the rest rather than animated into something it is not. */
(function () {
  function whenVisible(fn) {
    if (!document.hidden) return fn();
    document.addEventListener('visibilitychange', function once() {
      if (document.hidden) return;
      document.removeEventListener('visibilitychange', once);
      fn();
    });
  }

  function boot(root) {
    var boxes = (root || document).querySelectorAll('.figs2');
    if (!boxes.length) return;

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
    if (reduce && reduce.matches) return;
    if (!('IntersectionObserver' in window) || !('requestAnimationFrame' in window)) return;

    Array.prototype.forEach.call(boxes, function (box) {
      if (box.dataset.counted) return;
      box.dataset.counted = '1';

      var items = box.querySelectorAll('.figlead, .figgrid > *');
      if (!items.length) return;

      box.classList.add('nf-rise');

      var fired = false;
      function reveal() {
        if (fired) return;
        fired = true;
        Array.prototype.forEach.call(items, function (item, i) {
          setTimeout(function () {
            item.classList.add('in');
            var n = item.querySelector('[data-count]');
            if (n) count(n);
          }, i * 90);
        });
      }
      function showNow() {
        if (fired) return;
        fired = true;
        Array.prototype.forEach.call(items, function (item) { item.classList.add('in'); });
      }

      var io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            io.disconnect();
            whenVisible(reveal);
            return;
          }
        }
      }, { threshold: 0.2, rootMargin: '0px 0px -10% 0px' });

      io.observe(box);

      /* If the observer never fires — an old engine, a section inside a scroll
         container it cannot see — show everything anyway. The numbers are still
         their true selves at this point, so this costs only the animation. */
      setTimeout(function () { io.disconnect(); showNow(); }, 6000);
    });
  }

  function count(el) {
    var target = parseFloat(el.getAttribute('data-count'));
    var dec = parseInt(el.getAttribute('data-dec') || '0', 10);
    var ms = parseInt(el.getAttribute('data-ms') || '1100', 10);
    if (isNaN(target) || isNaN(ms) || ms < 1) return;

    var final = target.toFixed(dec);
    el.textContent = (0).toFixed(dec);

    /* Elapsed time decides the value, so a long gap between frames finishes the
       count rather than freezing it. */
    var start = null;
    function frame(now) {
      if (start === null) start = now;
      var p = (now - start) / ms;
      if (p >= 1) { el.textContent = final; return; }
      var eased = 1 - Math.pow(1 - p, 3);          /* ease-out cubic */
      el.textContent = (target * eased).toFixed(dec);
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);

    /* last resort: if frames never come at all, put the number back */
    setTimeout(function () { if (el.textContent !== final) el.textContent = final; }, ms + 3000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }
  /* the theme editor swaps a section out from under us */
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
